const template = require('../ui/templates/modal/share-embed.hbs');

class ModalShareEmbed {
  constructor (opts) {
    const that = this;

    this.opts = opts || {};

    this.$wrapper = $(
      this.opts.wrapper
        ? $(this.opts.wrapper)
        : $('<div class="tool-content"></div>')
    );

    initTemplate();
    initEvents();

    function initTemplate () {
      that.$wrapper.append(
        template({
          width: INKIVE.C.EMBED.DefaultWidth,
          height: INKIVE.C.EMBED.DefaultHeight
        })
      );
    }

    function initEvents () {
      that.$wrapper.find('a.type').on('click', function () {
        that.$wrapper.find('a.type').removeClass('active');
        $(this).addClass('active');

        if ($(this).attr('data-id') == 'scroll') {
          that.$wrapper.find('#share-embed-checkboxes').slideUp(function () {
            that.$wrapper.trigger('contentChanged');
          });
          that.$wrapper
            .find('#share-embed-size-text')
            .html(
              that.opts.text_size +
                ' (1.5 ' +
                (INKIVE.C.MODE.IS_DESYGNER ? 'designs' : 'pages') +
                ' at a time)'
            );
          that.$wrapper
            .find('#share-embed-size a.size:not([data-id=custom])')
            .each(function (index, elem) {
              const width = parseInt($(elem).attr('data-id'));
              const height = Math.round(width * INKIVE.C.EMBED.W2H * 1.5 + 40);
              $(elem).attr('tag', width + ' x ' + height);
            });
        } else {
          that.$wrapper.find('#share-embed-checkboxes').slideDown(function () {
            that.$wrapper.trigger('contentChanged');
          });
          that.$wrapper
            .find('#share-embed-size-text')
            .html(that.opts.text_size);
          that.$wrapper
            .find('#share-embed-size a.size:not([data-id=custom])')
            .each(function (index, elem) {
              const width = parseInt($(elem).attr('data-id'));
              const height = Math.round(width * INKIVE.C.EMBED.W2H);
              $(elem).attr('tag', width + ' x ' + height);
            });
        }

        calcUrl();
      });

      that.$wrapper.find('a.size').on('click', function () {
        that.$wrapper.find('a.size').removeClass('active');
        $(this).addClass('active');

        if ($(this).attr('data-id') == 'custom') {
          $(this).hide();
          that.$wrapper.find('#share-embed-custom-sizes').fadeIn();
        } else {
          that.$wrapper.find('#share-embed-custom-sizes').hide();
          that.$wrapper.find('a.size').show();
        }

        calcUrl();
      });

      that.$wrapper.find('input[name=width]').keyup(function (event) {
        const mode = that.$wrapper.find('a.type.active').attr('data-id');
        let width = parseInt($(this).val()) || 0;
        const height = parseInt(that.$wrapper.find('input[name=height]').val());

        if (width > INKIVE.C.EMBED.MaxWidth) {
          $(this).val(INKIVE.C.EMBED.MaxWidth);
          width = $(this).val();
        }

        if (mode == 'scroll') {
          if (
            width >
            Math.round(
              ((INKIVE.C.EMBED.DefaultHeight - 40) / INKIVE.C.EMBED.W2H) * 1.5
            )
          ) {
            that.$wrapper
              .find('input[name=height]')
              .val(Math.round(width * INKIVE.C.EMBED.W2H * 1.5 + 40));
          }
        } else {
          that.$wrapper
            .find('input[name=height]')
            .val(Math.round(width * INKIVE.C.EMBED.W2H));
        }

        calcUrl();
      });

      that.$wrapper.find('input[name=height]').keyup(function (event) {
        const mode = that.$wrapper.find('a.type.active').attr('data-id');
        const height = parseInt($(this).val()) || 0;

        if (mode != 'scroll') {
          let width = height / INKIVE.C.EMBED.W2H;

          if (width > INKIVE.C.EMBED.MaxWidth) {
            width = INKIVE.C.EMBED.MaxWidth;
            $(this).val(Math.round(width * INKIVE.C.EMBED.W2H));
          }

          that.$wrapper.find('input[name=width]').val(Math.round(width));
        }

        calcUrl();
      });

      that.$wrapper.find('textarea').on('click', function (event) {
        this.select();
      });

      that.$wrapper.find('[type=checkbox]').on('change', function () {
        calcUrl();
      });

      calcUrl();
    }

    function calcUrl () {
      const mode = that.$wrapper.find('a.type.active').attr('data-id');

      let width = INKIVE.C.EMBED.DefaultWidth;
      let height = INKIVE.C.EMBED.DefaultHeight;

      const display_bookName = that.$wrapper
        .find('[name=bookName]')
        .is(':checked')
        ? 1
        : 0;
      const display_bookViews = that.$wrapper
        .find('[name=bookViews]')
        .is(':checked')
        ? 1
        : 0;

      const $size = that.$wrapper.find('a.size.active');
      if ($size.attr('data-id') == 'custom') {
        width = that.$wrapper.find('input[name=width]').val() || width;
        height = that.$wrapper.find('input[name=height]').val() || height;
      } else {
        width = parseInt($size.attr('data-id'));
        if (mode == 'scroll') {
          height = Math.round(width * INKIVE.C.EMBED.W2H * 1.5 + 40);
        } else {
          height = Math.round(width * INKIVE.C.EMBED.W2H);
        }
      }

      const val =
        '<iframe src="' +
        INKIVE.C.BASE_URL.replace('http:', '') +
        'design/embedded/' +
        INKIVE.C.BOOK.id +
        '/' +
        width +
        '/' +
        height +
        '/' +
        mode +
        '/' +
        display_bookName +
        '/' +
        display_bookViews +
        '/" width="' +
        width +
        '" height="' +
        height +
        '" frameborder="0"></iframe>';

      that.$wrapper.find('textarea[name=code]').val(val);
    }
  }

  getFormHtml () {
    return this.$wrapper;
  }

  saveForm (callback) {
    callback && callback(true);
  }
}

module.exports = ModalShareEmbed;
